<template>
  <div v-if="acmgMap[acmgKey] && acmgTag" class="case-acmg-item-page" :class="{ active: acmgData[acmgKey], disabled: disabled }" :style="acmgStyles">
    <div class="case-acmg-item-container row-block">
      <div :style="{ flex: 1 }"></div>
      <div class="case-acmg-item-content row-block shrink">
        <img
          class="case-acmg-item-icon"
          :src="require('../../assets/images/acmg-checkbox-' + (acmgData[acmgKey] ? acmgType : acmgData[acmgKey] !== 0 ? 'empty' : 'disabled') + '.svg')"
          @click="e => $emit('setValue', acmgKey)"
        >
        <div :style="{ width: '5px' }"></div>
        <div class="case-acmg-item-title-container row-block shrink input-group" :title="getACMGTag()">
          <div class="case-acmg-item-title-block row-block shrink">
            <div class="case-acmg-item-title shrink ellipsis">{{ getACMGTag() }}</div>
            <img
              v-if="(acmgTagOptions || []).length"
              class="case-acmg-item-title-icon"
              :src="require('../../assets/images/acmg-slider-icon.svg')"
            >
          </div>
          <div class="case-acmg-item-tag-option">
            <select v-if="(acmgTagOptions || []).length" v-model="acmgTag" @change="e => $emit('setValue', acmgKey, acmgTag)">
              <option
                v-for="(option, oindex) in acmgTagOptions"
                :value="option.value"
                :key="oindex"
              >{{ option.title }}</option>
            </select>
          </div>
        </div>
      </div>
      <div :style="{ width: '7px' }"></div>
      <div class="case-acmg-item-info center-block">
        <borCor
          :width="'250px'"
          :background="'white'"
          :border="'#707070'"
          :radius="'0px'"
          :reverse="borCorReverse"
          :blockStyle="{ padding: '6px 8px' }"
        >
          <div slot="trigger">
            <img :src="require('../../assets/images/acmg-info-icon.svg')" alt="">
          </div>
          <div class="content col-block" slot="content">
            <div class="text" v-html="acmgMap[acmgKey].informations.map(info => $t(info)).join('<br>')"></div>
          </div>
        </borCor>
      </div>
      <div :style="{ flex: 1 }"></div>
    </div>
  </div>
</template>

<script>
import borCor from '../tool/borCor.vue'
import { acmgMap } from '../../constants/global/data'

export default {
  components: {
    borCor
  },
  props: {
    acmgData: {
      type: Object,
      required: true
    },
    acmgKey: {
      type: String,
      required: true
    },
    acmgType: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    borCorReverse: {
      type: Boolean,
      default: () => false
    }
  },
  data () {
    return {
      acmgTag: null
    }
  },
  computed: {
    acmgStyles () {
      return {
        'benign-strong': {
          '--bg-color': 'rgba(113, 72, 148, 0.1)',
          '--color': '#714894'
        },
        'benign-supporting': {
          '--bg-color': 'rgba(52, 156, 207, 0.1)',
          '--color': '#349CCF'
        },
        'pathogenic-supporting': {
          '--bg-color': 'rgba(131, 201, 30, 0.1)',
          '--color': '#83C91E'
        },
        'pathogenic-moderate': {
          '--bg-color': 'rgba(255, 158, 3, 0.1)',
          '--color': '#FF9E03'
        },
        'pathogenic-strong': {
          '--bg-color': 'rgba(250, 61, 61, 0.1)',
          '--color': '#FA3D3D'
        },
        'pathogenic-very-strong': {
          '--bg-color': 'rgba(190, 15, 15, 0.1)',
          '--color': '#BE0F0F'
        }
      }[this.acmgType]
    },
    acmgTagOptions () {
      let acmgNumber = (this.acmgKey.match(/^[^\d]*(\d+)/) || [])[1]
      let acmgKey = (this.acmgKey.match(/^([^\d]*)\d+/) || [])[1]
      if (acmgNumber) {
        const exceptionOptions = {
          'BA1': []
        }
        let acmgType = this.acmgKey.match(/^./)
        let acmgTagOptions = exceptionOptions[this.acmgKey] || {
          'P': ['PP', 'PM', 'PS', 'PVS'],
          'B': ['BS', 'BP']
        }[acmgType].filter(key => key !== acmgKey).map(key => ({ title: this.acmgKey + '(' + key + ')' + ((key + acmgNumber) === this.acmgTag ? ' ✓' : ''), value: key + acmgNumber }))
        return acmgTagOptions.length ? [{ title: this.acmgKey + (this.acmgKey === this.acmgTag ? ' ✓' : ''), value: this.acmgKey }, ...acmgTagOptions] : acmgTagOptions
      }
    },
    // global
    acmgMap () { return acmgMap }
  },
  watch: {
    'acmgData': {
      handler: function () {
        this.setACMGTag()
      },
      deep: true
    }
  },
  created () {
    this.setACMGTag()
  },
  methods: {
    setACMGTag () {
      let acmgTag = this.acmgData[this.acmgKey + '_tag']
      this.acmgTag = this.acmgTagOptions.map(option => option.value).includes(acmgTag) ? acmgTag : this.acmgKey
    },
    getACMGTag () {
      return this.acmgKey + (this.acmgKey !== this.acmgTag ? ('(' + this.acmgTag.match(/^([^\d]*)\d+/)[1] + ')') : '')
    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/case/acmgItem.vue